export const getPrimeOrFirstContactInfoValue = (contactInfos) => {
    const primeContactInfo = contactInfos.find((contactInfo) => contactInfo.prime);
    return primeContactInfo && primeContactInfo.value;
};
